import { CompType, schCompType } from '@aloft/toolkit-shared';
import { Image, Text, View } from '@react-pdf/renderer';

import logo from '../../../assets/logos/appraisify/appraisify-colored.png';
import { fontStyles, headerStyles } from '../styles.ts';
import { CompTypeBadge } from './CompTypeBadge.tsx';

export const Header = ({
  title,
  address,
  showAddress = true,
  badge,
}: {
  title: string;
  address: string;
  showAddress?: boolean;
  badge?: CompType;
}) => (
  <View style={headerStyles.header} fixed>
    <View style={headerStyles.titleWrapper}>
      <Text style={fontStyles.h3}>{title}</Text>
      {badge && (
        <CompTypeBadge compType={badge === 'arv' ? schCompType.enum.arv : schCompType.enum.aiv} />
      )}
    </View>
    {showAddress && (
      <View style={headerStyles.logoWrapper}>
        <Text style={fontStyles.bodyLight}>{address}</Text>
        <Image src={logo} style={headerStyles.logo} />
      </View>
    )}
  </View>
);
